module.exports = __webpack_public_path__ + "static/img/car.213278a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/car.png
// module id = eu9N
// module chunks = 0